import { Modal, Button } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface CompleteOnboardingModalProps {
  visible: boolean;
  onClose: () => void;
}

const CompleteOnboardingModal = ({
  visible,
  onClose,
}: CompleteOnboardingModalProps) => {
  const navigate = useNavigate();

  return (
    <Modal
      centered
      open={visible}
      onCancel={onClose}
      title="Your onboarding process has not been completed."
      footer={[
        <Button
          key="skip"
          onClick={() => {
            navigate('/booking');
            onClose();
          }}
        >
          Skip
        </Button>,
        <Button
          key="start"
          type="primary"
          onClick={() => {
            navigate('/onboarding');
            onClose();
          }}
        >
          Start onboarding
        </Button>,
      ]}
    >
      <p style={{ margin: '10px 0' }}>
        Complete this quick step to connect your accounts, tell us a little
        about your company, add your team, and see how effortless marketing can
        be.
      </p>
    </Modal>
  );
};

export default CompleteOnboardingModal;
